import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import Button from "shared/components/Button"
import openZendeskChat from "shared/services/zendesk/openZendeskChat"

import styles from "./CallToAction.module.css"

const CallToAction = props => {
  const { t: translate } = useTranslate()
  const { plan, onChangePlan, lang } = props

  const isCurrent = plan?.available_action === "Current"
  const canBuy = plan?.available_action === "Checkout"
  const canSubscribe = plan?.available_action === "Change Allowed"
  const checkoutPath = "/v3/checkout/billing"

  // Available button options:
  // Can add plan to existing subscription ; copy -> "Activate plan"
  // Can start paying action -> go to checkout ; copy -> "Activate plan"
  // It is already active - button disabled ; copy -> "Your current plan"
  // Contact us action -> zendeskChat ; copy -> "Contact us"

  if (isCurrent) {
    return (
      <div>
        <Button
          disabled
          className={styles.ctaBtn}
          variation="primary"
          buttonType="solid"
        >
          {translate("Your current plan")}
        </Button>
      </div>
    )
  }

  if (canBuy) {
    return (
      <div>
        <Button
          to={checkoutPath}
          state={plan}
          className={styles.ctaBtn}
          variation="primary"
          buttonType="solid"
        >
          {translate("Activate plan")}
        </Button>
      </div>
    )
  }

  if (canSubscribe) {
    return (
      <div>
        <Button
          onClick={() => onChangePlan(plan.name)}
          className={styles.ctaBtn}
          variation="primary"
          buttonType="solid"
        >
          {translate("Change plan")}
        </Button>
      </div>
    )
  }

  // No plans to subscribe to so Contact Us
  return (
    <div>
      <Button
        onClick={() => openZendeskChat(lang)}
        className={styles.ctaContactBtn}
        variation="primary"
        buttonType="border"
      >
        {translate("Contact us")}
      </Button>
    </div>
  )
}

CallToAction.propTypes = {
  plan: PropTypes.shape({
    name: PropTypes.string,
    available_action: PropTypes.string,
  }),
  onChangePlan: PropTypes.func,
}

CallToAction.defaultProps = {
  onChangePlan: () => {},
  plan: {},
}

export default CallToAction
